module.exports = __webpack_public_path__ + "img/product-placeholder-51.d82c620.png";